var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('PageHeader'),_c('ProjInfo',{attrs:{"projectInfo":_vm.projectInfo}}),_c('v-container',{staticClass:"section-block"},[_c('v-row',[_c('v-col',{staticClass:"col-12 col-md-8"})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }